import { render, staticRenderFns } from "./ExtraHealthAgreement.vue?vue&type=template&id=46850c4c&scoped=true"
import script from "./ExtraHealthAgreement.vue?vue&type=script&lang=js"
export * from "./ExtraHealthAgreement.vue?vue&type=script&lang=js"
import style0 from "./ExtraHealthAgreement.vue?vue&type=style&index=0&id=46850c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46850c4c",
  null
  
)

export default component.exports